import axios from "axios";

const backendUrl = process.env.REACT_APP_baseUrl;

export type LoginResult = {
  jwt: string;
  user?: Record<string, unknown>;
};

/**
 * Shared post-auth flow: exchange a Strapi JWT for /users/me and dispatch LOGIN_USER.
 */
export const completeLogin = async ({
  jwt,
  dispatch,
}: {
  jwt: string;
  dispatch: (action: { type: string; payload: any }) => void;
}) => {
  const meRes = await axios.get(`${backendUrl}/users/me`, {
    headers: {
      Authorization: `Bearer ${jwt}`,
      "Content-Type": "application/json",
    },
  });

  const me = meRes.data;

  dispatch({
    type: "LOGIN_USER",
    payload: {
      ...me,
      jwt,
    },
  });

  return me;
};

export const redirectAfterLogin = (history: { push: (path: string) => void }, me: any) => {
  // Check if this login is part of an MCP OAuth flow
  const mcpOAuthReturnUrl = localStorage.getItem("mcpOAuthReturnUrl");
  if (mcpOAuthReturnUrl) {
    localStorage.removeItem("mcpOAuthReturnUrl");
    history.push(mcpOAuthReturnUrl);
    return;
  }

  // Normal login redirect
  if (me?.selectedOrg?.role === "Admin" || me?.selectedOrg?.role === "Developer") {
    history.push("/dashboard");
  } else {
    history.push("/organizations");
  }
};
